import React from "react";
import GoBack from "shared/ui/GoBack";
import SelectMallContent from "widgets/SelectMallContent";
import s from "./style.module.scss";
import Button from "shared/ui/Button";
import { ROUTES_PATH } from "shared/constants/routesPath";

const SelectMall: React.FC = () => {
  return (
    <main className={s.select}>
      <GoBack black />

      <Button className={s.button} href={ROUTES_PATH.HOME}>
        Выбрать
      </Button>

      <section>
        <h1>Выберите районный центр</h1>

        <SelectMallContent />
      </section>
    </main>
  );
};

export default SelectMall;
